export default "__VITE_ASSET__ad2a5eaa__"